import React, { useContext, useEffect, useRef, useState } from 'react'
import IconSelectInput from '../../assets/iconTsx/DropDown'
import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'
import useClickOutside from '../../hooks/useOnclickOutside'
import Share from '../../assets/share.svg'
import maps from '../../assets/maps.svg'
import { toast } from 'react-toastify'
import LogoWafaCash from '../../assets/logoWafaCash.svg'
import LogoSwared from '../../assets/logoSwered.svg'
import LogoIZI from '../../assets/logoIZI.svg'
import LogoEnda from '../../assets/logoEnda.svg'
import New from '../../assets/newBlue.svg'
import PartnerMap from '../../assets/partner-map.svg'

interface Props {
  setColectPointId: (value: any) => void
  selectedOptionPointCollecte: any
  setSelectedOptionPointCollecte: (value: string) => void
  euroValue: any
  colectPointId: string
  selectedOptionReseaux: string
  setSelectedOptionReseaux: any
  getListPartenaireByCity: any
}

const partnerCard: React.FC<Props> = ({
  setColectPointId,
  selectedOptionPointCollecte,
  setSelectedOptionPointCollecte,
  euroValue,
 
  colectPointId,
  selectedOptionReseaux,
  setSelectedOptionReseaux,
  getListPartenaireByCity,
}) => {
  const { TransferData, setTransferData } = useContext(transferBeneficiaryContext)
  const [isOpenReseaux, setIsOpenReseaux] = useState(false)
  const [isOpenPointCollecte, setIsOpenPointCollecte] = useState(false)

  const [pointDeCollect, setPointDeCollect] = useState('')
  const [messageError, setMessageError] = useState(false)

  const divRef = useRef<HTMLDivElement>(null)
  const dropDownRef = useRef<HTMLDivElement>(null)

  const listeLogoPartenaire = [
    { name: 'Wafacash', image: LogoWafaCash },
    { name: 'Enda', image: LogoEnda, new:true },

    { name: 'Viamobile', image: LogoSwared },
    { name: 'Izi', image: LogoIZI },
  ]

  const toggleSetting = () => {
    setIsOpenReseaux(false)
    //setIsOpenPointCollecte(false)
  }

  useEffect (()=>{
    setSelectedOptionReseaux('')
    setPointDeCollect('')
    setColectPointId('')

    setIsOpenPointCollecte(false)
  },[TransferData?.ville])



  useClickOutside(toggleSetting, dropDownRef, divRef)

  //get List Partenaire By City


  const filteredPartenaire = getListPartenaireByCity
  .filter((item: any) => !(euroValue > 1000 && item.network.toLowerCase() === 'viamobile'))

  const listePartenaireToDisplay = listeLogoPartenaire
    .filter((logo) =>
      getListPartenaireByCity?.some( (partner: any) => partner.network.toLowerCase() === logo.name.toLowerCase()
      )
    )

     const handleSelectReseaux = (genre: any) => {
    {
      setSelectedOptionReseaux(genre)
      setTransferData({ ...TransferData,partenaire: genre, pointDeCollect: '' })

        setPointDeCollect('')
        setColectPointId('')
  
    }
  }

  useEffect(()=>{
    const fetchData= ()=>{
      const genre=  listePartenaireToDisplay[0].name
    
      if(genre !== selectedOptionReseaux)
      {
      setSelectedOptionReseaux(genre)

      setTransferData({ ...TransferData,partenaire: genre, pointDeCollect: '' })
      if(getListPartenaireByCity.length!==1)
            { 
              setPointDeCollect('')
              setColectPointId('')
            }
      }
    
    }
    if(listePartenaireToDisplay.length===1)
    {fetchData()}
  },[getListPartenaireByCity])

  useEffect(()=>{
    if(getListPartenaireByCity.length!==1) return

      
    const partenaire =  getListPartenaireByCity[0]
           setMessageError(false)
                      setColectPointId(partenaire._id)
                      setPointDeCollect(partenaire.storeInfo?.name)
                      if (selectedOptionReseaux === '') {
                        setTransferData({...TransferData, partenaire:partenaire.network})
                        setSelectedOptionReseaux(partenaire.network)
                      }

                  setIsOpenPointCollecte(false)
                  setTransferData({
                    ...TransferData,
                    pointDeCollect: pointDeCollect,
                    colectPointId: colectPointId,
                  })
        
    

  },[selectedOptionReseaux,getListPartenaireByCity])

  useEffect(() => {
    if (TransferData) {
      setSelectedOptionReseaux(TransferData?.partenaire || '')
      setSelectedOptionPointCollecte(TransferData?.pointDeCollect || '')
      setColectPointId(TransferData?.colectPointId || '')
    }
  }, [])
  
  useEffect(() => {
    if ((euroValue > 1000 && TransferData?.partenaire?.toLocaleLowerCase() === 'viamobile')) {
      setTransferData({...TransferData, partenaire:'', pointDeCollect:''})
      setSelectedOptionPointCollecte('')
      setSelectedOptionReseaux('')
      setColectPointId('')
    }
  }, [euroValue])

 


  const handleCopy = (adress: string, ville: string) => {
    const query = encodeURIComponent(adress + ville)
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${query}`

    navigator.clipboard.writeText(mapsUrl).then(() => {
      toast.info(`Lien copié dans le presse-papiers !`, {
        position: 'top-right',
        autoClose: 2000,
      })
    })
  }

  const handleClickOutside = (event: any) => {
    if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
      setIsOpenReseaux(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className=" space-y-6" ref={dropDownRef}>
      {listePartenaireToDisplay.length !== 0 && (
        <div ref={dropDownRef} className=" gap-1 relative w-full text-[#422EAE] ">
          <h2 className="h3" onClick={() => {setIsOpenReseaux(!isOpenReseaux)}}>
            Partenaire
          </h2>
          <div className="grid grid-cols-2 gap-5 mt-4 ">
            {listePartenaireToDisplay.map((item: any, index: number) => (
              <div  key={index}
              className={` ${selectedOptionReseaux === item.name  ? ' border border-[#5754E5]' : 'border border-[#AEB6FB]' } relative rounded-[10px] flex items-center cursor-pointer justify-center h-[55px] w-full`} 
                onClick={() => { if(item.name !== selectedOptionReseaux){handleSelectReseaux(item.name)} }}
              >
              <img  width={145} height={40} src={item.image} alt={item.name} />
              
              {item.new && <img src={New} width={21} height={21} className='absolute -top-2 -right-2 '/> }
              </div>
            ))}
          </div>       
        </div>
      )}

      <div ref={dropDownRef} className="flex flex-col gap-1 relative w-full ">
          <label className='h3'>Point de collecte</label>

        <div
          onClick={() => {if (TransferData?.ville) { setIsOpenPointCollecte(true) } }}
          
            className={`${!TransferData?.ville ? 'hover:cursor-not-allowed bg-[#F1F1FF] text-[#AEB6FB] ' 
              : !TransferData?.pointDeCollect? 'text-[#AEB6FB] cursor-pointer '
              :  isOpenPointCollecte && (TransferData?.pointDeCollect || pointDeCollect) ? 'text-[#5754E5]':  ' hover:cursor-pointer text-[#35258B]'} 
            flex h-[56px] items-center font-roboto border-[#AEB6FB] font-semibold  border px-4 justify-between rounded-[14px] `}
          >
          {pointDeCollect ? pointDeCollect : TransferData?.pointDeCollect ? TransferData?.pointDeCollect : 'Point de collecte'}
          
          <IconSelectInput styleCssImage='fill-[#AEB6FB]'/>

        </div>
        <div
          className={`absolute top-full scrollbar-webkit  z-10  max-h-[250px] rounded-b-lg  w-full shadow-selct text-[#1D3A70] bg-white overflow-y-auto 
                ${isOpenPointCollecte ? 'block' : 'hidden'}
                `}
        >
         
          {filteredPartenaire
            .filter((pt: any) => {
              if (selectedOptionReseaux !== '') {
                return pt?.network.toLowerCase() === selectedOptionReseaux.toLowerCase()
              }
              return true
            })

            .map((item: any, index: number) => (
              <div key={index} className={`  hover:bg-[#F6F6FD] hover:cursor-pointer  m-4`}>
                <div
                  className={`flex item-center  justify-between w-full border rounded-[10px] ${item._id === colectPointId ? 'bg-[#F6F6FD] border border-[#5754E5]' : 'border-[#AEB6FB]'}`}
                >
                 
                 
                    <div className={` w-full text-[14px] gap-1  flex flex-col  font-semibold text-[#AEB6FB] p-4`}
                    onClick={() => {
                      setMessageError(false)
                      setColectPointId(item?._id)
                      setPointDeCollect(item?.storeInfo?.name)
                      if (selectedOptionReseaux === '') {
                        setTransferData({...TransferData, partenaire:item.network})
                        setSelectedOptionReseaux(item.network)
                      }
                    }}
                     >
                      <span className={`${item._id === colectPointId ? 'text-[#5754E5]' : 'text-[#35258B]'} `}>{item?.storeInfo?.name}</span>
                      <div>
                        Téléphone :
                        <span className={`${item._id === colectPointId ? 'text-[#5754E5]' : 'text-[#35258B]'} pl-2`} >
                          {item?.storeInfo?.phoneNumber}
                        </span>
                      </div>
                      <div>
                        Adresse :
                        <span className={`${item._id === colectPointId ? 'text-[#5754E5]' : 'text-[#35258B]'} pl-2`} >
                          {item?.address?.street}
                        </span>
                      </div>
                    </div>
                 
                  {item._id === colectPointId ?
                    <div className="flex flex-col gap-6 items-center justify-center  border-l content-end w-[52px] border-[#5754E5]  my-5">
                    <img
                      className=" cursor-pointer"
                      onClick={() => {
                        const adresse = item?.storeInfo?.name + item?.address.city
                        const query = encodeURIComponent(adresse)
                        window.open(`https://www.google.com/maps/search/?api=1&query=${query}`, '_blank')
                      }}
                      src={maps}
                      width={16}
                      height={20}
                      alt="localisation de partenaire"
                    />
                    <img
                      className=" cursor-pointer"
                      src={Share}
                      width={16}
                      height={20}
                      alt="copier le lien"
                      onClick={() => {
                        const adress = item?.storeInfo?.name
                        const ville = item?.address.city
                        handleCopy(adress, ville)
                      }}
                    />
                  </div>
                  :
                  <img className='border-l  border-[#AEB6FB]' width={47}  src={PartnerMap} alt='map-design-mockup'/>
                  }
                </div>
              </div>
            ))}
          <div className="sticky bottom-0 flex p-4 flex-col  bg-[#FFFFFF] justify-center   ">
            {messageError && (
              <span className="text-[#E84148] text-xs"> Veuillez sélectionner un point de retrait avant de valider.</span>
            )}
            <button
              className={`w-full text-[#FFFFFF] font-bold  h-[56px] sm:h-[48px] sm:w-[150px] mx-auto rounded-[14px] ${selectedOptionPointCollecte || colectPointId ? 'bg-[#5754E5]' : 'bg-[#D1D1FF]'}  `}
              onClick={() => {
                if (colectPointId === '') {
                  ;(setMessageError(true), setIsOpenPointCollecte(true))
                } else {
                  setMessageError(false)
                  setIsOpenPointCollecte(false)
                  setTransferData({
                    ...TransferData,
                    pointDeCollect: pointDeCollect,
                    colectPointId: colectPointId,
                  })
                }
              }}
            >
              Valider
            </button>
          </div>
        </div>
      </div>
      {/* </label> */}
    </div>
  )
}

export default partnerCard
